// A prerendered route's DOM is replaced by React's first commit (the app uses createRoot, not hydration), which drops
// keyboard focus to <body> if the user had already tabbed into the static article. These two helpers remember the
// focused element while the static HTML is on screen and put focus back on the equivalent element after the swap.
// Only active on prerendered pages (they contain #prerender-spacer); a no-op everywhere else.

let last = null;
let tracking = false;

function describe(el) {
  if (!el || el === document.body) return null;
  const testid = el.getAttribute('data-testid');
  if (testid) return `[data-testid="${testid}"]`;
  if (el.id) return `#${CSS.escape(el.id)}`;
  const href = el.tagName === 'A' ? el.getAttribute('href') : null;
  if (href) return `a[href="${href.replace(/"/g, '\\"')}"]`;
  return null;
}

export function trackPrerenderFocus() {
  if (tracking || typeof document === 'undefined' || !document.getElementById('prerender-spacer')) return;
  tracking = true;
  const root = document.getElementById('root');
  last = root && root.contains(document.activeElement) ? describe(document.activeElement) : null;
  document.addEventListener('focusin', (e) => { if (tracking && root && root.contains(e.target)) last = describe(e.target); });
}

export function restorePrerenderFocus() {
  if (!tracking) return;
  tracking = false;
  const selector = last;
  last = null;
  if (!selector) return;
  if (document.activeElement && document.activeElement !== document.body) return; // focus already somewhere sensible
  const el = document.querySelector(selector);
  if (el) el.focus({ preventScroll: true });
}
